var map = {
	"./common/edu-games-plus-logo-black.svg": 604,
	"./common/edu-games-plus-logo.svg": 605,
	"./common/exam-papers-plus-logo.svg": 606,
	"./games/challenges/bar-graph/intro/intro-1.svg": 607,
	"./games/challenges/bar-graph/intro/primary.svg": 608,
	"./games/challenges/bomb-dodge/heart.svg": 609,
	"./games/challenges/bomb-dodge/intro/intro-1.svg": 610,
	"./games/challenges/bomb-dodge/intro/primary.svg": 611,
	"./games/challenges/cartesian-plane/intro/intro-1.svg": 612,
	"./games/challenges/cartesian-plane/intro/primary.svg": 613,
	"./games/challenges/cloze/cloze-flora.svg": 614,
	"./games/challenges/cloze/cloze-ground.svg": 615,
	"./games/challenges/cloze/cloze-rabbit-hole-decorations.svg": 312,
	"./games/challenges/cloze/cloze-rabbit-hole.svg": 313,
	"./games/challenges/cloze/cloze-rabbit-shadow.svg": 314,
	"./games/challenges/cloze/cloze-rabbit.svg": 315,
	"./games/challenges/cloze/intro/intro-1.svg": 616,
	"./games/challenges/cloze/intro/primary.svg": 617,
	"./games/challenges/common/intro/take-notes.svg": 618,
	"./games/challenges/custom-keyboard/custom-keyboard-bg-stars.svg": 619,
	"./games/challenges/custom-keyboard/custom-keyboard-bg.svg": 620,
	"./games/challenges/custom-keyboard/custom-keyboard-destination.svg": 316,
	"./games/challenges/custom-keyboard/custom-keyboard-planets.svg": 317,
	"./games/challenges/custom-keyboard/custom-keyboard-spaceship.svg": 318,
	"./games/challenges/custom-keyboard/intro/intro-1.svg": 621,
	"./games/challenges/custom-keyboard/intro/primary.svg": 622,
	"./games/challenges/drag-and-drop/order/intro/intro-1.svg": 623,
	"./games/challenges/drag-and-drop/order/intro/primary.svg": 624,
	"./games/challenges/drag-and-drop/order/worm-face-0.svg": 319,
	"./games/challenges/drag-and-drop/order/worm-face-1.svg": 320,
	"./games/challenges/drag-and-drop/order/worm-face-2.svg": 321,
	"./games/challenges/drag-and-drop/sort/intro/intro-1.svg": 625,
	"./games/challenges/drag-and-drop/sort/intro/primary.svg": 626,
	"./games/challenges/drag-and-drop/sort/meteor.svg": 627,
	"./games/challenges/drag-and-drop/sort/planet-blue.svg": 628,
	"./games/challenges/drag-and-drop/sort/planet-red.svg": 629,
	"./games/challenges/drag-and-drop/sort/planet-yellow.svg": 630,
	"./games/challenges/drag-and-drop/sort/word-bg.svg": 631,
	"./games/challenges/fractions/fractions-mountains.svg": 632,
	"./games/challenges/fractions/fractions-water.svg": 633,
	"./games/challenges/fractions/multiple-choice/intro/intro-1.svg": 634,
	"./games/challenges/fractions/multiple-choice/intro/primary.svg": 635,
	"./games/challenges/fractions/select/intro/intro-1.svg": 636,
	"./games/challenges/fractions/select/intro/primary.svg": 637,
	"./games/challenges/jumbled-words/intro/intro-1.svg": 638,
	"./games/challenges/jumbled-words/intro/primary.svg": 639,
	"./games/challenges/jumbled-words/jumbled-words-cloud.svg": 640,
	"./games/challenges/jumbled-words/jumbled-words-moon.svg": 641,
	"./games/challenges/jumbled-words/jumbled-words-penguin.svg": 322,
	"./games/challenges/jumbled-words/jumbled-words-polar-bear.svg": 323,
	"./games/challenges/jumbled-words/jumbled-words-rptr-fish.svg": 642,
	"./games/challenges/jumbled-words/jumbled-words-rptr-water.svg": 643,
	"./games/challenges/mass/intro/intro-1.svg": 644,
	"./games/challenges/mass/intro/primary.svg": 645,
	"./games/challenges/mass/mass-bg.svg": 646,
	"./games/challenges/mass/mass-scale-head.svg": 647,
	"./games/challenges/match-pairs/intro/intro-1.svg": 648,
	"./games/challenges/match-pairs/intro/primary.svg": 649,
	"./games/challenges/match-pairs/match-pairs-bg.svg": 650,
	"./games/challenges/match-pairs/match-pairs-face-sprite.svg": 324,
	"./games/challenges/match-pairs/match-pairs-flora.svg": 651,
	"./games/challenges/money/count/intro/intro-1.svg": 652,
	"./games/challenges/money/count/intro/primary.svg": 653,
	"./games/challenges/money/money-pence-fifty.svg": 325,
	"./games/challenges/money/money-pence-five.svg": 326,
	"./games/challenges/money/money-pence-one.svg": 327,
	"./games/challenges/money/money-pence-ten.svg": 328,
	"./games/challenges/money/money-pence-twenty.svg": 329,
	"./games/challenges/money/money-pence-two.svg": 330,
	"./games/challenges/money/money-pig.svg": 654,
	"./games/challenges/money/money-pounds-fifty.svg": 331,
	"./games/challenges/money/money-pounds-five.svg": 332,
	"./games/challenges/money/money-pounds-one.svg": 333,
	"./games/challenges/money/money-pounds-ten.svg": 334,
	"./games/challenges/money/money-pounds-twenty.svg": 335,
	"./games/challenges/money/money-pounds-two.svg": 336,
	"./games/challenges/money/solve/intro/intro-1.svg": 655,
	"./games/challenges/money/solve/intro/primary.svg": 656,
	"./games/challenges/multiple-choice/columns/intro/intro-1.svg": 657,
	"./games/challenges/multiple-choice/columns/intro/primary.svg": 658,
	"./games/challenges/multiple-choice/columns/multiple-choice-columns-cloud-1.svg": 659,
	"./games/challenges/multiple-choice/columns/multiple-choice-columns-cloud-2.svg": 660,
	"./games/challenges/multiple-choice/columns/multiple-choice-columns-cloud-3.svg": 661,
	"./games/challenges/multiple-choice/columns/multiple-choice-columns-rocketeer.svg": 337,
	"./games/challenges/multiple-choice/flip/intro/intro-1.svg": 662,
	"./games/challenges/multiple-choice/flip/intro/primary.svg": 663,
	"./games/challenges/multiple-choice/image/intro/intro-1.svg": 664,
	"./games/challenges/multiple-choice/image/intro/primary.svg": 665,
	"./games/challenges/multiple-choice/image/multiple-choice-image-bg.svg": 666,
	"./games/challenges/multiple-choice/image/multiple-choice-image-dest.svg": 667,
	"./games/challenges/multiple-choice/image/multiple-choice-image-flora.svg": 668,
	"./games/challenges/multiple-choice/image/multiple-choice-image-snail-trail.svg": 669,
	"./games/challenges/multiple-choice/image/multiple-choice-image-snail.svg": 670,
	"./games/challenges/multiple-choice/letters/intro/intro-1.svg": 671,
	"./games/challenges/multiple-choice/letters/intro/primary.svg": 672,
	"./games/challenges/multiple-choice/letters/multiple-choice-letters-flea.svg": 338,
	"./games/challenges/multiple-choice/letters/multiple-choice-letters-sun.svg": 673,
	"./games/challenges/multiple-choice/list/intro/intro-1.svg": 674,
	"./games/challenges/multiple-choice/list/intro/primary.svg": 675,
	"./games/challenges/multiple-choice/list/multiple-choice-list-bg.svg": 676,
	"./games/challenges/multiple-choice/list/multiple-choice-list-flora.svg": 677,
	"./games/challenges/multiple-choice/list/multiple-choice-list-jellyfish.svg": 339,
	"./games/challenges/multiple-choice/timed-cards/intro/intro-1.svg": 678,
	"./games/challenges/multiple-choice/timed-cards/intro/primary.svg": 679,
	"./games/challenges/multiple-choice/timed-fall/intro/intro-1.svg": 680,
	"./games/challenges/multiple-choice/timed-fall/intro/primary.svg": 681,
	"./games/challenges/multiple-choice/timed-fall/spikes.svg": 682,
	"./games/challenges/multiple-choice/timed/intro/intro-1.svg": 683,
	"./games/challenges/multiple-choice/timed/intro/primary.svg": 684,
	"./games/challenges/numberline/intro/intro-1.svg": 685,
	"./games/challenges/numberline/intro/primary.svg": 686,
	"./games/challenges/numberline/numberline-bg.svg": 687,
	"./games/challenges/numberline/numberline-fg.svg": 688,
	"./games/challenges/numberline/numberline-monkey.svg": 689,
	"./games/challenges/numberline/numberline-owl.svg": 690,
	"./games/challenges/numberline/numberline-parrot.svg": 691,
	"./games/challenges/numberline/numberline-snake.svg": 692,
	"./games/challenges/reflection/intro/intro-1.svg": 693,
	"./games/challenges/reflection/intro/primary.svg": 694,
	"./games/challenges/sequencing/intro/intro-1.svg": 695,
	"./games/challenges/sequencing/intro/primary.svg": 696,
	"./games/challenges/sequencing/sequencing-dog-grey.svg": 697,
	"./games/challenges/sequencing/sequencing-dog-white.svg": 698,
	"./games/challenges/sequencing/sequencing-dog-yellow.svg": 699,
	"./games/challenges/sequencing/sequencing-shadow.svg": 700,
	"./games/challenges/swipe-sort/intro/intro-1.svg": 701,
	"./games/challenges/swipe-sort/intro/primary.svg": 702,
	"./games/challenges/time/input/intro/intro-1.svg": 703,
	"./games/challenges/time/input/intro/primary.svg": 704,
	"./games/challenges/time/select/intro/intro-1.svg": 705,
	"./games/challenges/time/select/intro/primary.svg": 706,
	"./games/challenges/time/time-birdhouse.svg": 707,
	"./games/challenges/time/time-rptr.svg": 708,
	"./games/challenges/wheel/intro/intro-1.svg": 709,
	"./games/challenges/wheel/intro/primary.svg": 710,
	"./games/challenges/word-elimination/intro/intro-1.svg": 711,
	"./games/challenges/word-elimination/intro/primary.svg": 712,
	"./games/challenges/word-search/intro/intro-1.svg": 713,
	"./games/challenges/word-search/intro/primary.svg": 714,
	"./games/clouds-stars-bg.svg": 715,
	"./games/dashboard/welcome.svg": 716,
	"./games/edit-square.svg": 717,
	"./games/game-intro/slide-1/bg-desk.svg": 718,
	"./games/game-intro/slide-1/bg-palm.svg": 719,
	"./games/game-intro/slide-1/fg-desk.svg": 720,
	"./games/game-intro/slide-1/fg-palm.svg": 721,
	"./games/game-intro/slide-2/bg-desk.svg": 722,
	"./games/game-intro/slide-2/bg-palm.svg": 723,
	"./games/game-intro/slide-2/creatures.svg": 724,
	"./games/game-intro/slide-2/fg-desk.svg": 725,
	"./games/game-intro/slide-2/fg-palm.svg": 726,
	"./games/game-intro/slide-3/bg-desk-moon.svg": 727,
	"./games/game-intro/slide-3/bg-desk-water.svg": 728,
	"./games/game-intro/slide-3/bg-desk.svg": 729,
	"./games/game-intro/slide-3/bg-palm-water.svg": 730,
	"./games/game-intro/slide-3/bg-palm.svg": 731,
	"./games/game-intro/slide-3/fg-desk.svg": 732,
	"./games/game-intro/slide-3/fg-palm.svg": 733,
	"./games/game-intro/slide-4/bg-desk.svg": 734,
	"./games/game-intro/slide-4/bg-palm.svg": 735,
	"./games/game-intro/slide-4/fg-desk.svg": 736,
	"./games/game-intro/slide-4/fg-palm.svg": 737,
	"./games/game-intro/slide-4/monochrine.svg": 738,
	"./games/game-intro/slide-5/bg-desk-river.svg": 739,
	"./games/game-intro/slide-5/bg-desk.svg": 740,
	"./games/game-intro/slide-5/bg-palm-river.svg": 741,
	"./games/game-intro/slide-5/bg-palm.svg": 742,
	"./games/game-intro/slide-5/fg-desk.svg": 743,
	"./games/game-intro/slide-5/fg-palm.svg": 744,
	"./games/game-intro/slide-6/bg-desk-creature-1.svg": 745,
	"./games/game-intro/slide-6/bg-desk-creature-2.svg": 746,
	"./games/game-intro/slide-6/bg-desk-creature-3.svg": 747,
	"./games/game-intro/slide-6/bg-desk-creature-4.svg": 748,
	"./games/game-intro/slide-6/bg-desk-creature-5.svg": 749,
	"./games/game-intro/slide-6/bg-desk-creature-6.svg": 750,
	"./games/game-intro/slide-6/bg-desk-debris.svg": 751,
	"./games/game-intro/slide-6/bg-desk-spiral-1.svg": 752,
	"./games/game-intro/slide-6/bg-desk-spiral-2.svg": 753,
	"./games/game-intro/slide-6/bg-desk-spiral-3.svg": 754,
	"./games/game-intro/slide-6/bg-desk-spiral-4.svg": 755,
	"./games/game-intro/slide-6/bg-palm-creature-1.svg": 756,
	"./games/game-intro/slide-6/bg-palm-creature-2.svg": 757,
	"./games/game-intro/slide-6/bg-palm-creature-3.svg": 758,
	"./games/game-intro/slide-6/bg-palm-creature-4.svg": 759,
	"./games/game-intro/slide-6/bg-palm-creature-5.svg": 760,
	"./games/game-intro/slide-6/bg-palm-creature-6.svg": 761,
	"./games/game-intro/slide-6/bg-palm-debris.svg": 762,
	"./games/game-intro/slide-6/bg-palm-spiral-1.svg": 763,
	"./games/game-intro/slide-6/bg-palm-spiral-2.svg": 764,
	"./games/game-intro/slide-6/bg-palm-spiral-3.svg": 765,
	"./games/game-intro/slide-6/bg-palm-spiral-4.svg": 766,
	"./games/game-intro/slide-7/bg-desk.svg": 767,
	"./games/game-intro/slide-7/bg-palm.svg": 768,
	"./games/game-intro/slide-7/rubik-stars.svg": 769,
	"./games/game-intro/slide-7/rubik.svg": 770,
	"./games/post-challenge/post-challenge-lose-face.svg": 340,
	"./games/post-challenge/post-challenge-win-face.svg": 341,
	"./games/stages/crayona-kingdom/intro/slide-1/bg-desk.svg": 771,
	"./games/stages/crayona-kingdom/intro/slide-1/bg-palm.svg": 772,
	"./games/stages/crayona-kingdom/intro/slide-1/fg-desk.svg": 773,
	"./games/stages/crayona-kingdom/intro/slide-1/fg-left-desk.svg": 774,
	"./games/stages/crayona-kingdom/intro/slide-1/fg-left-palm.svg": 775,
	"./games/stages/crayona-kingdom/intro/slide-1/fg-right-desk.svg": 776,
	"./games/stages/crayona-kingdom/intro/slide-1/fg-right-palm.svg": 777,
	"./games/stages/crayona-kingdom/intro/slide-2/bg-desk.svg": 778,
	"./games/stages/crayona-kingdom/intro/slide-2/bg-palm.svg": 779,
	"./games/stages/crayona-kingdom/intro/slide-2/creature-arm-left.svg": 780,
	"./games/stages/crayona-kingdom/intro/slide-2/creature-arm-right.svg": 781,
	"./games/stages/crayona-kingdom/intro/slide-2/creature.svg": 782,
	"./games/stages/crayona-kingdom/intro/slide-2/fg-desk.svg": 783,
	"./games/stages/crayona-kingdom/intro/slide-2/fg-left-palm.svg": 784,
	"./games/stages/crayona-kingdom/intro/slide-2/fg-right-palm.svg": 785,
	"./games/stages/crayona-kingdom/intro/slide-3/bg-desk.svg": 786,
	"./games/stages/crayona-kingdom/intro/slide-3/bg-grass-desk.svg": 787,
	"./games/stages/crayona-kingdom/intro/slide-3/bg-grass-palm.svg": 788,
	"./games/stages/crayona-kingdom/intro/slide-3/bg-palm.svg": 789,
	"./games/stages/crayona-kingdom/intro/slide-3/creature-arm-left.svg": 790,
	"./games/stages/crayona-kingdom/intro/slide-3/creature-arm-right.svg": 791,
	"./games/stages/crayona-kingdom/intro/slide-3/creature-tears.svg": 792,
	"./games/stages/crayona-kingdom/intro/slide-3/creature.svg": 793,
	"./games/stages/crayona-kingdom/intro/slide-3/fg-left-desk.svg": 794,
	"./games/stages/crayona-kingdom/intro/slide-3/fg-right-desk.svg": 795,
	"./games/stages/crayona-kingdom/outro/slide-1/bg-desk.svg": 796,
	"./games/stages/crayona-kingdom/outro/slide-1/bg-palm.svg": 797,
	"./games/stages/crayona-kingdom/outro/slide-1/creature-desk.svg": 798,
	"./games/stages/crayona-kingdom/outro/slide-1/creature-palm.svg": 799,
	"./games/stages/crayona-kingdom/outro/slide-2/bg-desk.svg": 800,
	"./games/stages/crayona-kingdom/outro/slide-2/bg-palm.svg": 801,
	"./games/stages/crayona-kingdom/outro/slide-2/creature-desk.svg": 802,
	"./games/stages/crayona-kingdom/outro/slide-2/creature-palm.svg": 803,
	"./games/stages/crayona-kingdom/outro/slide-2/fg-desk.svg": 804,
	"./games/stages/crayona-kingdom/outro/slide-3/bg-desk.svg": 805,
	"./games/stages/crayona-kingdom/outro/slide-3/bg-palm.svg": 806,
	"./games/stages/crayona-kingdom/outro/slide-3/gems-desk.svg": 807,
	"./games/stages/crayona-kingdom/outro/slide-3/gems-palm.svg": 808,
	"./games/stages/crayona-kingdom/outro/slide-4/bg-desk.svg": 809,
	"./games/stages/crayona-kingdom/outro/slide-4/bg-palm.svg": 810,
	"./games/stages/crayona-kingdom/outro/slide-4/creature-desk.svg": 811,
	"./games/stages/crayona-kingdom/outro/slide-4/creature-palm.svg": 812,
	"./games/stages/crayona-kingdom/outro/slide-4/fg-desk.svg": 813,
	"./games/stages/crayona-kingdom/outro/slide-5/bg-desk.svg": 814,
	"./games/stages/crayona-kingdom/outro/slide-5/bg-palm.svg": 815,
	"./games/stages/crayona-kingdom/outro/slide-5/creature-desk.svg": 816,
	"./games/stages/crayona-kingdom/outro/slide-5/creature-palm.svg": 817,
	"./games/stages/crayona-kingdom/outro/slide-6/bg-desk.svg": 818,
	"./games/stages/crayona-kingdom/outro/slide-6/bg-palm.svg": 819,
	"./games/stages/crayona-kingdom/outro/slide-6/bg-volcano-desk.svg": 820,
	"./games/stages/crayona-kingdom/outro/slide-6/fg-desk.svg": 821,
	"./games/stages/crayona-kingdom/outro/slide-7/bg-desk.svg": 822,
	"./games/stages/crayona-kingdom/outro/slide-7/bg-palm.svg": 823,
	"./games/stages/crayona-kingdom/outro/slide-7/creatures-desk.svg": 824,
	"./games/stages/crayona-kingdom/outro/slide-7/creatures-palm.svg": 825,
	"./games/stages/crayona-kingdom/outro/slide-7/fg-desk.svg": 826,
	"./games/stages/desert-sands/intro/bg-sky-desk.svg": 827,
	"./games/stages/desert-sands/intro/bg-sky-palm.svg": 828,
	"./games/stages/desert-sands/intro/slide-1/bg-desk.svg": 829,
	"./games/stages/desert-sands/intro/slide-1/bg-palm.svg": 830,
	"./games/stages/desert-sands/intro/slide-1/fg-desk.svg": 831,
	"./games/stages/desert-sands/intro/slide-2/bg-desk.svg": 832,
	"./games/stages/desert-sands/intro/slide-2/bg-palm.svg": 833,
	"./games/stages/desert-sands/intro/slide-3/bg-desk.svg": 834,
	"./games/stages/desert-sands/intro/slide-3/bg-palm.svg": 835,
	"./games/stages/desert-sands/intro/slide-3/creature.svg": 836,
	"./games/stages/desert-sands/intro/sun-desk.svg": 837,
	"./games/stages/desert-sands/intro/sun-palm.svg": 838,
	"./games/stages/desert-sands/outro/bg-desk.svg": 839,
	"./games/stages/desert-sands/outro/creature-desk.svg": 840,
	"./games/stages/desert-sands/outro/creature-palm.svg": 841,
	"./games/stages/desert-sands/outro/gem.svg": 842,
	"./games/stages/hovering-heights/intro/slide-1/bg-desk.svg": 843,
	"./games/stages/hovering-heights/intro/slide-1/bg-palm.svg": 844,
	"./games/stages/hovering-heights/intro/slide-2/bg-desk.svg": 845,
	"./games/stages/hovering-heights/intro/slide-2/bg-palm.svg": 846,
	"./games/stages/hovering-heights/intro/slide-3/bg-desk.svg": 847,
	"./games/stages/hovering-heights/intro/slide-3/bg-palm.svg": 848,
	"./games/stages/hovering-heights/intro/slide-3/creature.svg": 849,
	"./games/stages/hovering-heights/outro/bg-desk.svg": 850,
	"./games/stages/hovering-heights/outro/bg-palm.svg": 851,
	"./games/stages/hovering-heights/outro/creature-desk.svg": 852,
	"./games/stages/hovering-heights/outro/creature-palm.svg": 853,
	"./games/stages/hovering-heights/outro/gem.svg": 854,
	"./games/stages/howling-kingdom/intro/creature-hat.svg": 855,
	"./games/stages/howling-kingdom/intro/creature.svg": 856,
	"./games/stages/howling-kingdom/intro/slide-1/bg-desk.svg": 857,
	"./games/stages/howling-kingdom/intro/slide-1/bg-palm.svg": 858,
	"./games/stages/howling-kingdom/intro/slide-2/bg-desk.svg": 859,
	"./games/stages/howling-kingdom/intro/slide-2/bg-palm.svg": 860,
	"./games/stages/howling-kingdom/intro/slide-3/bg-desk.svg": 861,
	"./games/stages/howling-kingdom/intro/slide-3/bg-palm.svg": 862,
	"./games/stages/howling-kingdom/outro/creature-desk.svg": 863,
	"./games/stages/howling-kingdom/outro/creature-palm.svg": 864,
	"./games/stages/howling-kingdom/outro/gem.svg": 865,
	"./games/stages/jeepers-jungle/intro/slide-1/bg-desk.svg": 866,
	"./games/stages/jeepers-jungle/intro/slide-1/bg-palm.svg": 867,
	"./games/stages/jeepers-jungle/intro/slide-1/fg-desk.svg": 868,
	"./games/stages/jeepers-jungle/intro/slide-1/fg-left-palm.svg": 869,
	"./games/stages/jeepers-jungle/intro/slide-1/fg-palm.svg": 870,
	"./games/stages/jeepers-jungle/intro/slide-1/fg-right-palm.svg": 871,
	"./games/stages/jeepers-jungle/intro/slide-2/bg-desk.svg": 872,
	"./games/stages/jeepers-jungle/intro/slide-2/bg-palm.svg": 873,
	"./games/stages/jeepers-jungle/intro/slide-3/creature-tree.svg": 874,
	"./games/stages/jeepers-jungle/intro/slide-3/creature.svg": 875,
	"./games/stages/jeepers-jungle/intro/slide-3/fg-left-palm.svg": 876,
	"./games/stages/jeepers-jungle/intro/slide-3/fg-right-palm.svg": 877,
	"./games/stages/jeepers-jungle/outro/bg-desk.svg": 878,
	"./games/stages/jeepers-jungle/outro/bg-rays-palm.svg": 879,
	"./games/stages/jeepers-jungle/outro/creature-desk.svg": 880,
	"./games/stages/jeepers-jungle/outro/creature-palm.svg": 881,
	"./games/stages/jeepers-jungle/outro/gem.svg": 882,
	"./games/stages/jelly-isle/intro/creature-leg.svg": 883,
	"./games/stages/jelly-isle/intro/creature.svg": 884,
	"./games/stages/jelly-isle/intro/slide-1/bg-desk.svg": 885,
	"./games/stages/jelly-isle/intro/slide-1/bg-palm.svg": 886,
	"./games/stages/jelly-isle/intro/slide-2/bg-desk.svg": 887,
	"./games/stages/jelly-isle/intro/slide-2/bg-palm.svg": 888,
	"./games/stages/jelly-isle/intro/slide-3/bg-desk.svg": 889,
	"./games/stages/jelly-isle/intro/slide-3/bg-palm.svg": 890,
	"./games/stages/jelly-isle/outro/creature-desk.svg": 891,
	"./games/stages/jelly-isle/outro/creature-palm.svg": 892,
	"./games/stages/jelly-isle/outro/gem.svg": 893,
	"./games/stages/lava-island/intro/slide-1/bg-desk.svg": 894,
	"./games/stages/lava-island/intro/slide-1/bg-palm.svg": 895,
	"./games/stages/lava-island/intro/slide-1/fg-desk.svg": 896,
	"./games/stages/lava-island/intro/slide-1/fg-palm.svg": 897,
	"./games/stages/lava-island/intro/slide-2/bg-desk.svg": 898,
	"./games/stages/lava-island/intro/slide-2/bg-palm.svg": 899,
	"./games/stages/lava-island/intro/slide-2/fg-desk.svg": 900,
	"./games/stages/lava-island/intro/slide-2/fg-palm.svg": 901,
	"./games/stages/lava-island/intro/slide-3/bg-desk.svg": 902,
	"./games/stages/lava-island/intro/slide-3/bg-palm.svg": 903,
	"./games/stages/lava-island/intro/slide-3/creature-desk.svg": 904,
	"./games/stages/lava-island/intro/slide-3/creature-palm.svg": 905,
	"./games/stages/lava-island/intro/slide-3/fg-desk.svg": 906,
	"./games/stages/lava-island/outro/bg-desk.svg": 907,
	"./games/stages/lava-island/outro/creature-desk.svg": 908,
	"./games/stages/lava-island/outro/creature-palm.svg": 909,
	"./games/stages/lava-island/outro/gem.svg": 910,
	"./games/stages/sunken-island/intro/slide-1/bg-desk.svg": 911,
	"./games/stages/sunken-island/intro/slide-1/bg-palm.svg": 912,
	"./games/stages/sunken-island/intro/slide-1/bg-sky-desk.svg": 913,
	"./games/stages/sunken-island/intro/slide-1/bg-sky-palm.svg": 914,
	"./games/stages/sunken-island/intro/slide-1/fg-fish-desk.svg": 915,
	"./games/stages/sunken-island/intro/slide-1/fg-fish-palm.svg": 916,
	"./games/stages/sunken-island/intro/slide-1/fg-water-desk.svg": 917,
	"./games/stages/sunken-island/intro/slide-1/fg-water-palm.svg": 918,
	"./games/stages/sunken-island/intro/slide-2/bg-desk.svg": 919,
	"./games/stages/sunken-island/intro/slide-2/bg-palm.svg": 920,
	"./games/stages/sunken-island/intro/slide-2/fg-fish-desk.svg": 921,
	"./games/stages/sunken-island/intro/slide-2/fg-fish-palm.svg": 922,
	"./games/stages/sunken-island/intro/slide-3/bg-desk.svg": 923,
	"./games/stages/sunken-island/intro/slide-3/bg-palm.svg": 924,
	"./games/stages/sunken-island/intro/slide-3/creature.svg": 925,
	"./games/stages/sunken-island/outro/creature-desk.svg": 926,
	"./games/stages/sunken-island/outro/creature-palm.svg": 927,
	"./games/stages/sunken-island/outro/gem.svg": 928,
	"./games/stages/uppity-island/intro/creature-bubble.svg": 929,
	"./games/stages/uppity-island/intro/creature.svg": 930,
	"./games/stages/uppity-island/intro/slide-1/bg-desk.svg": 931,
	"./games/stages/uppity-island/intro/slide-1/bg-palm.svg": 932,
	"./games/stages/uppity-island/intro/slide-2/bg-desk.svg": 933,
	"./games/stages/uppity-island/intro/slide-2/bg-palm.svg": 934,
	"./games/stages/uppity-island/intro/slide-3/bg-desk.svg": 935,
	"./games/stages/uppity-island/intro/slide-3/bg-palm.svg": 936,
	"./games/stages/uppity-island/outro/bg-desk.svg": 937,
	"./games/stages/uppity-island/outro/creature-desk.svg": 938,
	"./games/stages/uppity-island/outro/creature-palm.svg": 939,
	"./games/stages/uppity-island/outro/gem.svg": 940,
	"./games/stages/winter-freeze/intro/bg-snow-1.svg": 941,
	"./games/stages/winter-freeze/intro/bg-snow-2.svg": 942,
	"./games/stages/winter-freeze/intro/bg-snow-3.svg": 943,
	"./games/stages/winter-freeze/intro/slide-1/bg-desk.svg": 944,
	"./games/stages/winter-freeze/intro/slide-1/bg-palm.svg": 945,
	"./games/stages/winter-freeze/intro/slide-2/bg-desk.svg": 946,
	"./games/stages/winter-freeze/intro/slide-2/bg-palm.svg": 947,
	"./games/stages/winter-freeze/intro/slide-3/bg-desk.svg": 948,
	"./games/stages/winter-freeze/intro/slide-3/bg-palm.svg": 949,
	"./games/stages/winter-freeze/intro/slide-3/creature.svg": 950,
	"./games/stages/winter-freeze/outro/creature-desk.svg": 951,
	"./games/stages/winter-freeze/outro/creature-palm.svg": 952,
	"./games/stages/winter-freeze/outro/gem.svg": 953,
	"./games/stars-bg.svg": 954,
	"./games/thumbs/challenges/bar-graph.svg": 955,
	"./games/thumbs/challenges/bomb-dodge.svg": 956,
	"./games/thumbs/challenges/cartesian-plane.svg": 957,
	"./games/thumbs/challenges/cloze.svg": 958,
	"./games/thumbs/challenges/custom-keyboard.svg": 959,
	"./games/thumbs/challenges/drag-and-drop-order.svg": 960,
	"./games/thumbs/challenges/drag-and-drop-sort.svg": 961,
	"./games/thumbs/challenges/fractions-multiple-choice.svg": 962,
	"./games/thumbs/challenges/fractions-select.svg": 963,
	"./games/thumbs/challenges/jumbled-words.svg": 964,
	"./games/thumbs/challenges/mass.svg": 965,
	"./games/thumbs/challenges/match-pairs.svg": 966,
	"./games/thumbs/challenges/money-count.svg": 967,
	"./games/thumbs/challenges/money-solve.svg": 968,
	"./games/thumbs/challenges/multiple-choice-columns.svg": 969,
	"./games/thumbs/challenges/multiple-choice-flip.svg": 970,
	"./games/thumbs/challenges/multiple-choice-image.svg": 971,
	"./games/thumbs/challenges/multiple-choice-letters.svg": 972,
	"./games/thumbs/challenges/multiple-choice-list.svg": 973,
	"./games/thumbs/challenges/multiple-choice-timed-cards.svg": 974,
	"./games/thumbs/challenges/multiple-choice-timed-fall.svg": 975,
	"./games/thumbs/challenges/multiple-choice-timed.svg": 976,
	"./games/thumbs/challenges/numberline.svg": 977,
	"./games/thumbs/challenges/reflection.svg": 978,
	"./games/thumbs/challenges/sequencing.svg": 979,
	"./games/thumbs/challenges/swipe-sort.svg": 980,
	"./games/thumbs/challenges/time-input.svg": 981,
	"./games/thumbs/challenges/time-select.svg": 982,
	"./games/thumbs/challenges/wheel.svg": 983,
	"./games/thumbs/challenges/word-elimination.svg": 984,
	"./games/thumbs/challenges/word-search.svg": 985,
	"./games/thumbs/islands/crayona-kingdom/dots.svg": 986,
	"./games/thumbs/islands/crayona-kingdom/gem.svg": 987,
	"./games/thumbs/islands/crayona-kingdom/primary.svg": 988,
	"./games/thumbs/islands/desert-sands/background.svg": 989,
	"./games/thumbs/islands/desert-sands/dots.svg": 990,
	"./games/thumbs/islands/desert-sands/gem.svg": 991,
	"./games/thumbs/islands/desert-sands/primary.svg": 992,
	"./games/thumbs/islands/hovering-heights/background.svg": 993,
	"./games/thumbs/islands/hovering-heights/dots.svg": 994,
	"./games/thumbs/islands/hovering-heights/gem.svg": 995,
	"./games/thumbs/islands/hovering-heights/primary.svg": 996,
	"./games/thumbs/islands/howling-kingdom/background.svg": 997,
	"./games/thumbs/islands/howling-kingdom/dots.svg": 998,
	"./games/thumbs/islands/howling-kingdom/gem.svg": 999,
	"./games/thumbs/islands/howling-kingdom/primary.svg": 1000,
	"./games/thumbs/islands/jeepers-jungle/background.svg": 1001,
	"./games/thumbs/islands/jeepers-jungle/dots.svg": 1002,
	"./games/thumbs/islands/jeepers-jungle/gem.svg": 1003,
	"./games/thumbs/islands/jeepers-jungle/primary.svg": 1004,
	"./games/thumbs/islands/jelly-isle/background.svg": 1005,
	"./games/thumbs/islands/jelly-isle/dots.svg": 1006,
	"./games/thumbs/islands/jelly-isle/gem.svg": 1007,
	"./games/thumbs/islands/jelly-isle/primary.svg": 1008,
	"./games/thumbs/islands/lava-island/background.svg": 1009,
	"./games/thumbs/islands/lava-island/dots.svg": 1010,
	"./games/thumbs/islands/lava-island/gem.svg": 1011,
	"./games/thumbs/islands/lava-island/primary.svg": 1012,
	"./games/thumbs/islands/sunken-island/background.svg": 1013,
	"./games/thumbs/islands/sunken-island/dots.svg": 1014,
	"./games/thumbs/islands/sunken-island/gem.svg": 1015,
	"./games/thumbs/islands/sunken-island/primary.svg": 1016,
	"./games/thumbs/islands/uppity-island/background.svg": 1017,
	"./games/thumbs/islands/uppity-island/dots.svg": 1018,
	"./games/thumbs/islands/uppity-island/gem.svg": 1019,
	"./games/thumbs/islands/uppity-island/primary.svg": 1020,
	"./games/thumbs/islands/winter-freeze/background.svg": 1021,
	"./games/thumbs/islands/winter-freeze/dots.svg": 1022,
	"./games/thumbs/islands/winter-freeze/gem.svg": 1023,
	"./games/thumbs/islands/winter-freeze/primary.svg": 1024,
	"./inline-icons/account-holder-portal/bar-graph.svg": 1025,
	"./inline-icons/account-holder-portal/bullet-list.svg": 1026,
	"./inline-icons/account-holder-portal/cash-money.svg": 1027,
	"./inline-icons/account-holder-portal/profile.svg": 1028,
	"./inline-icons/account-holder-portal/wallet.svg": 1029,
	"./inline-icons/common/arrow-down.svg": 1030,
	"./inline-icons/common/arrow-left.svg": 1031,
	"./inline-icons/common/arrow-right.svg": 1032,
	"./inline-icons/common/arrow-up.svg": 1033,
	"./inline-icons/common/backspace.svg": 1034,
	"./inline-icons/common/btn-arrow-left.svg": 1035,
	"./inline-icons/common/btn-arrow-right.svg": 1036,
	"./inline-icons/common/burger.svg": 1037,
	"./inline-icons/common/checkbox-inside.svg": 1038,
	"./inline-icons/common/checkbox-outside.svg": 1039,
	"./inline-icons/common/chevron-down.svg": 1040,
	"./inline-icons/common/chevron-left.svg": 1041,
	"./inline-icons/common/chevron-right.svg": 1042,
	"./inline-icons/common/chevron-up.svg": 1043,
	"./inline-icons/common/cross.svg": 1044,
	"./inline-icons/common/facebook.svg": 1045,
	"./inline-icons/common/heart.svg": 1046,
	"./inline-icons/common/linkedin.svg": 1047,
	"./inline-icons/common/lock.svg": 1048,
	"./inline-icons/common/magnifying-glass.svg": 1049,
	"./inline-icons/common/marker.svg": 1050,
	"./inline-icons/common/minus.svg": 1051,
	"./inline-icons/common/pause.svg": 1052,
	"./inline-icons/common/play.svg": 1053,
	"./inline-icons/common/plus.svg": 1054,
	"./inline-icons/common/profile.svg": 1055,
	"./inline-icons/common/radio-inside.svg": 1056,
	"./inline-icons/common/radio-outside.svg": 1057,
	"./inline-icons/common/reload.svg": 1058,
	"./inline-icons/common/star.svg": 1059,
	"./inline-icons/common/tick.svg": 1060,
	"./inline-icons/common/twitter.svg": 1061,
	"./inline-icons/common/volume-off.svg": 1062,
	"./inline-icons/common/volume-on.svg": 1063,
	"./inline-icons/game-admin-portal/bar-graph.svg": 1064,
	"./inline-icons/game-admin-portal/bullet-list.svg": 1065,
	"./inline-icons/game-admin-portal/cash-money.svg": 1066,
	"./inline-icons/game-admin-portal/game-spelling.svg": 1067,
	"./inline-icons/game-admin-portal/play.svg": 1068,
	"./inline-icons/game-admin-portal/profile.svg": 1069,
	"./inline-icons/games/mc-columns-cloud-1.svg": 1070,
	"./inline-icons/games/mc-columns-cloud-2.svg": 1071,
	"./inline-icons/games/mc-columns-cloud-3.svg": 1072,
	"./inline-icons/games/mc-flip.svg": 1073,
	"./inline-icons/marketing/pencil-and-ruler.svg": 1074,
	"./inline/games/challenges/bomb-dodge/bomb.svg": 205,
	"./inline/games/challenges/bomb-dodge/hint.svg": 206,
	"./inline/games/challenges/bomb-dodge/player.svg": 207,
	"./inline/games/challenges/word-elimination/candle.svg": 208,
	"./inline/games/challenges/word-elimination/icing.svg": 209,
	"./marketing/about/banner/bg-creature-palm.svg": 1075,
	"./marketing/about/banner/bg-creatures-desk.svg": 1076,
	"./marketing/about/banner/bg-desk.svg": 1077,
	"./marketing/about/banner/bg-flora-desk.svg": 1078,
	"./marketing/about/banner/bg-flora-palm.svg": 1079,
	"./marketing/about/banner/bg-palm.svg": 1080,
	"./marketing/about/banner/bg-spacer-desk.svg": 1081,
	"./marketing/about/banner/bg-spacer-palm.svg": 1082,
	"./marketing/about/faisal-nasim-edu-games-plus.jpg": 1083,
	"./marketing/about/spaceship.svg": 1084,
	"./marketing/contact/banner/bg-desk.svg": 1085,
	"./marketing/contact/banner/bg-flora-left-desk.svg": 1086,
	"./marketing/contact/banner/bg-flora-palm.svg": 1087,
	"./marketing/contact/banner/bg-flora-right-desk.svg": 1088,
	"./marketing/contact/banner/bg-palm.svg": 1089,
	"./marketing/contact/banner/bg-spacer-desk.svg": 1090,
	"./marketing/contact/banner/bg-spacer-palm.svg": 1091,
	"./marketing/courses/banner-bg.svg": 1092,
	"./marketing/courses/banner-games-bg-flat.svg": 1093,
	"./marketing/courses/banner-games-bg.svg": 1094,
	"./marketing/courses/basket-icon.svg": 1095,
	"./marketing/courses/basket-penguin.svg": 1096,
	"./marketing/courses/checkbox-tick.svg": 1097,
	"./marketing/courses/down-arrow.svg": 1098,
	"./marketing/courses/english_icon.svg": 1099,
	"./marketing/courses/entrance-exams.svg": 1100,
	"./marketing/courses/features/comprehension-icon.svg": 1101,
	"./marketing/courses/features/grammar-icon.svg": 1102,
	"./marketing/courses/features/punctuation-icon.svg": 1103,
	"./marketing/courses/features/spelling-icon.svg": 1104,
	"./marketing/courses/features/vocabulary-icon.svg": 1105,
	"./marketing/courses/green-tick.svg": 1106,
	"./marketing/courses/hat.svg": 1107,
	"./marketing/courses/header/Desktop.svg": 1108,
	"./marketing/courses/header/Mobile.svg": 1109,
	"./marketing/courses/header/Tablet.svg": 1110,
	"./marketing/courses/included-penguin.svg": 1111,
	"./marketing/courses/maths_icon.svg": 1112,
	"./marketing/courses/mobile-tablet.svg": 1113,
	"./marketing/courses/performance-tracking.svg": 1114,
	"./marketing/courses/quote-bg.svg": 1115,
	"./marketing/courses/reviewer-avatar.png": 1116,
	"./marketing/courses/star-gold.svg": 1117,
	"./marketing/courses/star-gray.svg": 1118,
	"./marketing/courses/stepper-minus.svg": 1119,
	"./marketing/courses/stepper-plus.svg": 1120,
	"./marketing/courses/trending-up-outline.svg": 1121,
	"./marketing/default/banner/balloon-large.svg": 1122,
	"./marketing/default/banner/balloon-small.svg": 1123,
	"./marketing/default/banner/bg-clouds-desk.svg": 1124,
	"./marketing/default/banner/bg-clouds-palm.svg": 1125,
	"./marketing/default/banner/bg-palm.svg": 1126,
	"./marketing/default/banner/bg-spacer-desk.svg": 1127,
	"./marketing/default/banner/bg-spacer-palm.svg": 1128,
	"./marketing/explore/banner/bg-desk-spacer.svg": 1129,
	"./marketing/explore/banner/bg-desk.svg": 1130,
	"./marketing/explore/banner/bg-palm-spacer.svg": 1131,
	"./marketing/explore/banner/bg-palm.svg": 1132,
	"./marketing/explore/banner/rubik.svg": 1133,
	"./marketing/explore/strip-mobile-dashboard-desk.png": 1134,
	"./marketing/explore/strip-mobile-rocketeer-desk.png": 1135,
	"./marketing/explore/strip-mobile-user-management-desk.png": 1136,
	"./marketing/explore/strip-owl-desk.svg": 1137,
	"./marketing/explore/strip-owl-palm.svg": 1138,
	"./marketing/explore/strip-penguin-desk.svg": 1139,
	"./marketing/explore/strip-tablet-bear-desk.png": 1140,
	"./marketing/explore/strip-tablet-islands-desk.png": 1141,
	"./marketing/explore/strip-tablet-user-progress-maths-desk.png": 1142,
	"./marketing/games/banner/bg-clouds-stars.svg": 1143,
	"./marketing/games/banner/bg-desk-spacer.svg": 1144,
	"./marketing/games/banner/bg-stars.svg": 1145,
	"./marketing/games/fish.svg": 1146,
	"./marketing/games/polar-bear.svg": 1147,
	"./marketing/games/ripples.svg": 1148,
	"./marketing/home/banner/bg-desk-spacer.svg": 1149,
	"./marketing/home/banner/bg-desk.svg": 1150,
	"./marketing/home/banner/bg-flora-desk.svg": 1151,
	"./marketing/home/banner/bg-flora-palm.svg": 1152,
	"./marketing/home/banner/bg-palm-spacer.svg": 1153,
	"./marketing/home/banner/bg-palm.svg": 1154,
	"./marketing/home/banner/bg-water-desk.svg": 1155,
	"./marketing/home/benefit-dashboard.svg": 1156,
	"./marketing/home/benefit-devices.svg": 1157,
	"./marketing/home/benefit-feedback.svg": 1158,
	"./marketing/home/strip-cellphone-desk.png": 1159,
	"./marketing/home/strip-cellphone-palm.png": 1160,
	"./marketing/home/strip-rocketeer-desk.svg": 1161,
	"./marketing/home/strip-rocketeer-palm.svg": 1162,
	"./marketing/home/strip-tablet-desk.png": 1163,
	"./marketing/home/strip-tablet-palm.png": 1164,
	"./marketing/home/value-hat.svg": 1165,
	"./marketing/home/value-pencil.svg": 1166,
	"./marketing/home/value-tablet.svg": 1167,
	"./marketing/tip/banner/bg-desk.svg": 1168,
	"./marketing/tip/banner/bg-flora-desk.svg": 1169,
	"./marketing/tip/banner/bg-flora-palm.svg": 1170,
	"./marketing/tip/banner/bg-spacer-desk.svg": 1171,
	"./marketing/tip/banner/bg-spacer-palm.svg": 1172,
	"./marketing/tips/banner/balloon-large.svg": 1173,
	"./marketing/tips/banner/balloon-small.svg": 1174,
	"./marketing/tips/banner/bg-clouds.svg": 1175,
	"./marketing/tips/banner/bg-desk.svg": 1176,
	"./marketing/tips/banner/bg-palm.svg": 1177,
	"./marketing/tips/banner/bg-spacer-desk.svg": 1178,
	"./marketing/tips/banner/bg-spacer-palm.svg": 1179,
	"./portal/powered-by-stripe-logo.svg": 342
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var id = map[req];
		if(!(id + 1)) { // check for number or string
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return id;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 603;
module.exports = webpackAsyncContext;